import { genId } from "./editorUtils.js";

let counter = 0;
function id() {
  counter += 1;
  return `tpl_${Date.now().toString(36)}_${counter}`;
}

function tx(text, x, y, w, h, fontSize = 8, bold = false, align = "left", color = "#000000") {
  return { id: id(), type: "text", x, y, w, h, text, fontSize, bold, align, color };
}
function fld(label, fieldKey, x, y, w, h = 6, fontSize = 9) {
  return { id: id(), type: "field", x, y, w, h, label, fieldKey, fontSize, boxed: true };
}
function area(label, fieldKey, x, y, w, h, fontSize = 8) {
  return { id: id(), type: "textarea", x, y, w, h, label, fieldKey, fontSize, boxed: true };
}
// Los bloques de los documentos comerciales no llevan recuadro: recargan el
// diseño. Se marca sólo una línea fina al pie del bloque.
function box(x, y, w, h, _borderWidth = 0.4, color = "#d1d5db") {
  return { id: id(), type: "rect", x, y: y + h, w, h: 0.3, borderWidth: 0, borderColor: "", background: color };
}
function img(src, x, y, w, h) {
  return { id: id(), type: "image", x, y, w, h, src };
}
function tabla(x, y, w, h, groupTitle, columns, rows = 12) {
  return {
    id: id(),
    type: "table",
    x,
    y,
    w,
    h,
    columns,
    rows,
    headerFontSize: 8,
    showRowNumbers: false,
    groupTitle,
    estilo: "limpia",
  };
}

function linea(x, y, w, color = "#000000") {
  return { id: id(), type: "rect", x, y, w, h: 0.6, borderWidth: 0, background: color };
}

function logo(x, y, w, h) {
  return img("{{empresa.logo}}", x, y, w, h);
}

// ---------- Documentos comerciales ----------

export function buildFacturaVenta() {
  const cols = [
    { title: "CONCEPTO", width: 0.46 },
    { title: "CANT.", width: 0.09 },
    { title: "PRECIO", width: 0.13 },
    { title: "DTO", width: 0.08 },
    { title: "IVA", width: 0.08 },
    { title: "IMPORTE", width: 0.16 },
  ];
  const t = tabla(20, 95, 170, 110, "DETALLE", cols, 14);
  return {
    id: id(),
    builtin: "factura-venta",
    name: "Factura de venta",
    tipoDocumento: "factura-venta",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),
      // El bloque de título termina en x=162: la esquina superior derecha
      // queda reservada para el QR tributario VeriFactu.
      tx("FACTURA", 102, 16, 60, 10, 18, true, "right", "#111827"),
      tx("{{documento.numero}}", 102, 27, 60, 6, 11, false, "right", "#4b5563"),
      tx("Fecha: {{documento.fecha}}", 102, 34, 60, 5, 9, false, "right", "#6b7280"),

      box(20, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("EMISOR", 23, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{empresa.nombre}}", 23, 51, 74, 8, 10, true),
      tx("{{empresa.nif}}", 23, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{empresa.direccion}}", 23, 65, 74, 7, 8, false, "left", "#374151"),

      box(110, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("CLIENTE", 113, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 113, 51, 74, 8, 10, true),
      tx("{{cliente.nif}}", 113, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.direccion}}", 113, 65, 74, 7, 8, false, "left", "#374151"),

      t,

      box(130, 210, 60, 34, 0.4, "#e5e7eb"),
      tx("Base imponible", 134, 215, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.base}}", 170, 215, 16, 5, 9, true, "right"),
      tx("IVA", 134, 223, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.iva}}", 170, 223, 16, 5, 9, true, "right"),
      linea(134, 232, 52, "#9ca3af"),
      tx("TOTAL", 134, 236, 34, 7, 11, true, "left"),
      tx("{{totales.total}}", 170, 236, 16, 7, 11, true, "right"),

      tx("Forma de pago: {{pago.metodo}}", 20, 210, 90, 5, 9, false, "left", "#4b5563"),
      tx("Vencimiento: {{pago.vencimiento}}", 20, 218, 90, 5, 9, false, "left", "#4b5563"),
      tx("{{notas}}", 20, 228, 100, 16, 8, false, "left", "#6b7280"),

      tx("Gracias por confiar en nosotros", 20, 268, 170, 5, 8, false, "center", "#9ca3af"),
    ],
  };
}

export function buildPresupuestoVenta() {
  const cols = [
    { title: "CONCEPTO", width: 0.46 },
    { title: "CANT.", width: 0.09 },
    { title: "PRECIO", width: 0.13 },
    { title: "DTO", width: 0.08 },
    { title: "IVA", width: 0.08 },
    { title: "IMPORTE", width: 0.16 },
  ];
  const t = tabla(20, 95, 170, 110, "DETALLE", cols, 14);
  return {
    id: id(),
    builtin: "presupuesto-venta",
    name: "Presupuesto de venta",
    tipoDocumento: "presupuesto-venta",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),
      tx("PRESUPUESTO", 120, 16, 70, 10, 18, true, "right", "#111827"),
      tx("{{documento.numero}}", 120, 27, 70, 6, 11, false, "right", "#4b5563"),
      tx("Fecha: {{documento.fecha}}", 120, 34, 70, 5, 9, false, "right", "#6b7280"),
      tx("Validez: {{documento.validez}}", 120, 40, 70, 5, 9, false, "right", "#6b7280"),

      box(20, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("EMISOR", 23, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{empresa.nombre}}", 23, 51, 74, 8, 10, true),
      tx("{{empresa.nif}}", 23, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{empresa.direccion}}", 23, 65, 74, 7, 8, false, "left", "#374151"),

      box(110, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("CLIENTE", 113, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 113, 51, 74, 8, 10, true),
      tx("{{cliente.nif}}", 113, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.direccion}}", 113, 65, 74, 7, 8, false, "left", "#374151"),

      t,

      box(130, 210, 60, 34, 0.4, "#e5e7eb"),
      tx("Base imponible", 134, 215, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.base}}", 170, 215, 16, 5, 9, true, "right"),
      tx("IVA", 134, 223, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.iva}}", 170, 223, 16, 5, 9, true, "right"),
      linea(134, 232, 52, "#9ca3af"),
      tx("TOTAL", 134, 236, 34, 7, 11, true, "left"),
      tx("{{totales.total}}", 170, 236, 16, 7, 11, true, "right"),

      tx("Este presupuesto no tiene carácter contractual hasta su aceptación.", 20, 268, 170, 5, 8, false, "center", "#9ca3af"),
    ],
  };
}

export function buildAlbaranVenta() {
  const cols = [
    { title: "CONCEPTO", width: 0.55 },
    { title: "CANT.", width: 0.12 },
    { title: "PRECIO", width: 0.18 },
    { title: "IMPORTE", width: 0.15 },
  ];
  const t = tabla(20, 95, 170, 110, "DETALLE", cols, 14);
  return {
    id: id(),
    builtin: "albaran-venta",
    name: "Albarán de venta",
    tipoDocumento: "albaran-venta",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),
      tx("ALBARÁN", 130, 16, 60, 10, 18, true, "right", "#111827"),
      tx("{{documento.numero}}", 130, 27, 60, 6, 11, false, "right", "#4b5563"),
      tx("Fecha: {{documento.fecha}}", 130, 34, 60, 5, 9, false, "right", "#6b7280"),

      box(20, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("EMISOR", 23, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{empresa.nombre}}", 23, 51, 74, 8, 10, true),
      tx("{{empresa.nif}}", 23, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{empresa.direccion}}", 23, 65, 74, 7, 8, false, "left", "#374151"),

      box(110, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("CLIENTE", 113, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 113, 51, 74, 8, 10, true),
      tx("{{cliente.nif}}", 113, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.direccion}}", 113, 65, 74, 7, 8, false, "left", "#374151"),

      t,

      tx("Conforme recepción de mercancía:", 20, 218, 80, 5, 9, true, "left"),
      { id: id(), type: "signature", x: 20, y: 225, w: 80, h: 20, label: "Nombre y firma" },

      tx("Gracias por confiar en nosotros", 20, 268, 170, 5, 8, false, "center", "#9ca3af"),
    ],
  };
}

export function buildPedidoCliente() {
  const cols = [
    { title: "CONCEPTO", width: 0.55 },
    { title: "CANT.", width: 0.12 },
    { title: "PRECIO", width: 0.18 },
    { title: "IMPORTE", width: 0.15 },
  ];
  const t = tabla(20, 95, 170, 110, "DETALLE DEL PEDIDO", cols, 14);
  return {
    id: id(),
    builtin: "pedido-cliente",
    name: "Pedido de cliente",
    tipoDocumento: "pedido-cliente",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),
      tx("PEDIDO", 130, 16, 60, 10, 18, true, "right", "#111827"),
      tx("{{documento.numero}}", 130, 27, 60, 6, 11, false, "right", "#4b5563"),
      tx("Fecha: {{documento.fecha}}", 130, 34, 60, 5, 9, false, "right", "#6b7280"),

      box(20, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("EMISOR", 23, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{empresa.nombre}}", 23, 51, 74, 8, 10, true),
      tx("{{empresa.nif}}", 23, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{empresa.direccion}}", 23, 65, 74, 7, 8, false, "left", "#374151"),

      box(110, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("CLIENTE", 113, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 113, 51, 74, 8, 10, true),
      tx("{{cliente.nif}}", 113, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.direccion}}", 113, 65, 74, 7, 8, false, "left", "#374151"),

      t,

      box(130, 210, 60, 34, 0.4, "#e5e7eb"),
      tx("Base imponible", 134, 215, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.base}}", 170, 215, 16, 5, 9, true, "right"),
      tx("IVA", 134, 223, 34, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.iva}}", 170, 223, 16, 5, 9, true, "right"),
      linea(134, 232, 52, "#9ca3af"),
      tx("TOTAL", 134, 236, 34, 7, 11, true, "left"),
      tx("{{totales.total}}", 170, 236, 16, 7, 11, true, "right"),
    ],
  };
}

// ---------- Taller / SAT ----------

export function buildParteTaller() {
  const cols = [
    { title: "CONCEPTO", width: 0.52 },
    { title: "TIPO", width: 0.14 },
    { title: "CANT.", width: 0.09 },
    { title: "PRECIO", width: 0.12 },
    { title: "IMPORTE", width: 0.13 },
  ];
  const t = tabla(20, 120, 170, 84, "TRABAJOS Y MATERIALES", cols, 12);
  return {
    id: id(),
    builtin: "parte-taller",
    name: "Parte de trabajo (taller)",
    tipoDocumento: "parte-taller",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 40, 18),
      tx("PARTE DE TRABAJO", 110, 16, 80, 10, 17, true, "right", "#111827"),
      tx("{{documento.numero}}", 110, 27, 80, 6, 11, false, "right", "#4b5563"),
      tx("Fecha entrada: {{vehiculo.entrada}}", 110, 34, 80, 5, 9, false, "right", "#6b7280"),

      box(20, 38, 80, 26, 0.4, "#e5e7eb"),
      tx("CLIENTE", 23, 41, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 23, 47, 74, 6, 10, true),
      tx("{{cliente.nif}}", 23, 54, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.telefono}}", 23, 59, 74, 5, 8, false, "left", "#374151"),

      box(110, 38, 80, 30, 0.4, "#e5e7eb"),
      tx("VEHÍCULO", 113, 41, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{vehiculo.matricula}}", 113, 47, 74, 6, 10, true),
      tx("{{vehiculo.marca}} {{vehiculo.modelo}}", 113, 54, 74, 5, 8, false, "left", "#374151"),
      tx("{{vehiculo.km}} km", 113, 59, 74, 5, 8, false, "left", "#374151"),
      tx("{{seguro.texto}}", 113, 64, 74, 5, 8, true, "left", "#1e40af"),

      tx("Trabajo solicitado", 20, 74, 170, 5, 8, true, "left", "#6b7280"),
      box(20, 80, 170, 37, 0.4, "#e5e7eb"),
      // El motivo va en negrita y un trabajo por renglón, como se apunta en
      // el taller. La zona es alta (33 mm) para que quepan varios trabajos;
      // si aun así no cabe, el visor reduce la letra y la caja crece: nunca
      // se corta. Las cabeceras "POR CUENTA DE..." llegan subrayadas.
      tx("{{trabajos.motivo}}", 23, 83, 164, 32, 12, true, "left", "#111827"),

      t,

      box(130, 210, 60, 30, 0.4, "#e5e7eb"),
      tx("TOTAL", 134, 228, 34, 7, 11, true, "left"),
      tx("{{totales.total}}", 170, 228, 16, 7, 11, true, "right"),

      tx("Firma conforme cliente", 20, 215, 80, 5, 9, true, "left"),
      box(20, 222, 80, 20, 0.4, "#e5e7eb"),
    ],
  };
}

// Documento resumido para el operario: solo los trabajos a realizar, sin
// precios ni tabla. La aseguradora queda como referencia y las cabeceras
// "POR CUENTA DE..." van subrayadas (las marca listaTrabajos en el servidor).
export function buildTrabajosRealizar() {
  return {
    id: id(),
    builtin: "trabajos-realizar",
    name: "Trabajos a realizar",
    tipoDocumento: "parte-taller",
    porDefecto: false,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 40, 18),
      tx("TRABAJOS A REALIZAR", 100, 16, 90, 10, 16, true, "right", "#111827"),
      tx("{{documento.numero}}", 100, 27, 90, 6, 11, false, "right", "#4b5563"),
      tx("Fecha entrada: {{vehiculo.entrada}}", 100, 34, 90, 5, 9, false, "right", "#6b7280"),

      box(20, 38, 80, 26, 0.4, "#e5e7eb"),
      tx("CLIENTE", 23, 41, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 23, 47, 74, 6, 10, true),
      tx("{{cliente.nif}}", 23, 54, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.telefono}}", 23, 59, 74, 5, 8, false, "left", "#374151"),

      box(110, 38, 80, 30, 0.4, "#e5e7eb"),
      tx("VEHÍCULO", 113, 41, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{vehiculo.matricula}}", 113, 47, 74, 6, 10, true),
      tx("{{vehiculo.marca}} {{vehiculo.modelo}}", 113, 54, 74, 5, 8, false, "left", "#374151"),
      tx("{{vehiculo.km}} km", 113, 59, 74, 5, 8, false, "left", "#374151"),
      tx("{{seguro.texto}}", 113, 64, 74, 5, 8, true, "left", "#1e40af"),

      // Lista que ocupa la página: un trabajo por renglón, letra grande.
      // Si no cupiera, la letra se ajusta y la caja crece: nunca se corta.
      tx("Trabajos a realizar", 20, 74, 170, 5, 8, true, "left", "#6b7280"),
      box(20, 80, 170, 200, 0.4, "#e5e7eb"),
      tx("{{trabajos.motivo}}", 23, 84, 164, 192, 12, true, "left", "#111827"),
    ],
  };
}

export function buildParteSat() {
  const cols = [
    { title: "CONCEPTO", width: 0.52 },
    { title: "TIPO", width: 0.14 },
    { title: "CANT.", width: 0.09 },
    { title: "PRECIO", width: 0.12 },
    { title: "IMPORTE", width: 0.13 },
  ];
  const t = tabla(20, 130, 170, 80, "TRABAJOS Y PIEZAS", cols, 10);
  return {
    id: id(),
    builtin: "parte-sat",
    name: "Parte de trabajo (SAT)",
    tipoDocumento: "parte-sat",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 40, 18),
      tx("PARTE DE TRABAJO SAT", 100, 16, 90, 10, 16, true, "right", "#111827"),
      tx("{{documento.numero}}", 100, 27, 90, 6, 11, false, "right", "#4b5563"),
      tx("Fecha entrada: {{documento.fecha}}", 100, 34, 90, 5, 9, false, "right", "#6b7280"),

      box(20, 40, 80, 26, 0.4, "#e5e7eb"),
      tx("CLIENTE", 23, 43, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 23, 49, 74, 6, 10, true),
      tx("{{cliente.nif}}", 23, 56, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.telefono}}", 23, 61, 74, 5, 8, false, "left", "#374151"),

      box(110, 40, 80, 26, 0.4, "#e5e7eb"),
      tx("APARATO", 113, 43, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{aparato.descripcion}}", 113, 49, 74, 6, 9, true),
      tx("{{aparato.marca}} {{aparato.modelo}}", 113, 56, 74, 5, 8, false, "left", "#374151"),
      tx("S/N: {{aparato.serie}}", 113, 61, 74, 5, 8, false, "left", "#374151"),

      tx("Avería / síntoma", 20, 72, 170, 5, 8, true, "left", "#6b7280"),
      box(20, 78, 170, 18, 0.4, "#e5e7eb"),
      tx("{{aparato.averia}}", 23, 82, 164, 11, 9, false, "left", "#374151"),

      tx("Diagnóstico / trabajo realizado", 20, 100, 170, 5, 8, true, "left", "#6b7280"),
      box(20, 106, 170, 18, 0.4, "#e5e7eb"),
      tx("{{aparato.diagnostico}}", 23, 110, 164, 11, 9, false, "left", "#374151"),

      t,

      box(130, 220, 60, 26, 0.4, "#e5e7eb"),
      tx("TOTAL", 134, 236, 34, 7, 11, true, "left"),
      tx("{{totales.total}}", 170, 236, 16, 7, 11, true, "right"),

      tx("Firma conforme cliente", 20, 222, 80, 5, 9, true, "left"),
      box(20, 229, 80, 18, 0.4, "#e5e7eb"),
    ],
  };
}

// ---------- Recepciones (mantenemos las existentes, ajustadas al nuevo almacenamiento) ----------

function tx2(text, x, y, w, h, fontSize = 8, bold = false, align = "left") {
  return { id: id(), type: "text", x, y, w, h, text, fontSize, bold, align, color: "#000000" };
}
function fld2(label, fieldKey, x, y, w, h = 6, fontSize = 9) {
  return { id: id(), type: "field", x, y, w, h, label, fieldKey, fontSize, boxed: true };
}
function chk(label, fieldKey, x, y, w, h = 5, fontSize = 7, bold = false) {
  return { id: id(), type: "checkbox", x, y, w, h, label, fieldKey, fontSize, bold };
}
function box2(x, y, w, h, borderWidth = 1.5) {
  return { id: id(), type: "rect", x, y, w, h, borderWidth, borderColor: "#000000", background: "" };
}
function firma(label, sublabel, x, y, w, h) {
  return { id: id(), type: "signature", x, y, w, h, label, sublabel };
}

export function buildRecepcionVehiculo() {
  const tablaReparaciones = {
    id: id(), type: "table", x: 18, y: 62, w: 132, h: 78,
    columns: [
      { title: "DESCRIPCIÓN", width: 0.67 },
      { title: "MANO DE OBRA", width: 0.165 },
      { title: "MATERIALES", width: 0.165 },
    ],
    rows: 14, headerFontSize: 6, showRowNumbers: true,
    groupTitle: "REPARACIONES A REALIZAR",
  };

  return {
    id: id(),
    builtin: "recepcion-vehiculo",
    name: "Recepción de Vehículo",
    tipoDocumento: "entrada-taller",
    porDefecto: true,
    page: { size: "A4", orientation: "landscape" },
    elements: [
      tx2("EJEMPLAR PARA EL PRESTADOR DEL SERVICIO", 18, 8, 266, 7, 15, true, "center"),
      fld2("NOMBRE DEL TALLER", "taller.nombre", 18, 15, 84, 8),
      fld2("CIF", "taller.cif", 107, 15, 35, 8),
      fld2("DIRECCIÓN", "taller.direccion", 18, 25, 84, 8),
      fld2("TELÉFONO", "taller.telefono", 107, 25, 35, 8),
      fld2("MAIL", "taller.mail", 18, 35, 84, 8),
      tx2("RESGUARDO DE DEPÓSITO SIN PRESUPUESTO Nº:", 152, 16.5, 88, 4, 7, true),
      fld2("", "resguardo.numero", 240, 15.5, 44, 6),
      fld2("TITULAR DEL VEHÍCULO", "cliente.titular", 152, 23, 80, 8),
      fld2("CIF/DNI TITULAR", "cliente.cifTitular", 236, 23, 48, 8),
      fld2("PERSONA SOLICITANTE", "cliente.solicitante", 152, 31.5, 80, 8),
      fld2("CIF/DNI SOLICITANTE", "cliente.cifSolicitante", 236, 31.5, 48, 8),
      fld2("DIRECCIÓN TITULAR", "cliente.direccion", 152, 40, 80, 8),
      fld2("TELÉFONO", "cliente.telefono", 236, 40, 48, 8),
      fld2("MAIL", "cliente.mail", 152, 48.5, 80, 8),
      fld2("FECHA", "vehiculo.fecha", 183, 57, 30, 8),
      fld2("MATRÍCULA", "vehiculo.matricula", 217, 57, 32, 8),
      fld2("MARCA", "vehiculo.marca", 253, 57, 31, 8),
      fld2("KM", "vehiculo.km", 183, 67, 30, 8),
      tx2("SEGURO", 217, 70, 14, 4, 6, true),
      chk("SI", "vehiculo.seguroSi", 232, 69, 11, 5),
      chk("NO", "vehiculo.seguroNo", 244, 69, 12, 5),
      fld2("MODELO", "vehiculo.modelo", 260, 67, 24, 8),
      tx2("COMBUSTIBLE", 183, 79, 24, 4, 6, true),
      chk("R", "vehiculo.combR", 208, 78, 9, 5),
      chk("1/4", "vehiculo.comb14", 218, 78, 11, 5),
      chk("1/2", "vehiculo.comb12", 230, 78, 11, 5),
      chk("3/4", "vehiculo.comb34", 242, 78, 11, 5),
      chk("1", "vehiculo.comb1", 254, 78, 9, 5),
      area("SEGURO / FRANQUICIA", "seguro.detalle", 183, 85, 101, 9),
      tablaReparaciones,
      // Bloque amplio para describir la avería (impreso o a mano): era la
      // carencia que señalaba el taller — el antiguo cuadro de observaciones
      // de 9 mm no daba para nada.
      area("DESCRIPCIÓN DE LA AVERÍA / TRABAJOS SOLICITADOS POR EL CLIENTE", "vehiculo.descripcion", 18, 144, 132, 30),
      box2(152, 97, 132, 53, 2),
      tx2("RENUNCIA A LA ELABORACIÓN", 156, 99, 124, 6, 12, true, "center"),
      tx2("DE PRESUPUESTO PREVIO", 156, 105.5, 124, 6, 12, true, "center"),
      tx2("EL CLIENTE TIENE DERECHO A LA ELABORACIÓN DE UN PRESUPUESTO PREVIO. MEDIANTE LA PRESENTE FIRMA EL USUARIO RENUNCIA A LA ELABORACIÓN DE PRESUPUESTO PREVIO Y AUTORIZA A REALIZAR LOS TRABAJOS NECESARIOS PARA LA REPARACIÓN DEL VEHÍCULO Y/O SERVICIOS SOLICITADOS CONFORME A LO REFLEJADO EN ESTE RESGUARDO DE DEPÓSITO.", 157, 113, 122, 12, 5, true),
      tx2("EL PRESTADOR DEL SERVICIO", 157, 137, 62, 3.5, 6, true),
      tx2("CONFORME CLIENTE", 224, 137, 56, 3.5, 6, true),
      tx2("NOMBRE DEL TALLER", 157, 141.5, 62, 4, 7, false),
      firma("", "", 224, 140, 56, 9),
      tx2("FECHA PREVISTA DE ENTREGA DEL VEHÍCULO REPARADO", 160, 153, 88, 4, 7, true),
      fld2("", "entrega.fechaPrevista", 250, 152, 34, 6),
      tx2("EL CLIENTE CON LA FIRMA ANTERIOR AUTORIZA AL TALLER A:", 152, 160, 132, 4, 7, true),
      chk("REALIZAR DESPLAZAMIENTOS DE DIAGNÓSTICO", "autoriza.desplazamientos", 152, 166, 64, 8, 5, true),
      chk("UTILIZAR ELEMENTOS, EQUIPOS O CONJUNTOS USADOS O NO ESPECÍFICOS (ART 9 Y 10 DECRETO 9/2003)", "autoriza.usados", 220, 166, 64, 8, 5, true),
      chk("UTILIZAR ELEMENTOS, EQUIPOS O CONJUNTOS RECONSTRUIDOS (ART 9 Y 10 DECRETO 9/2003)", "autoriza.reconstruidos", 152, 175, 64, 8, 5, true),
      chk("RENUNCIA A RETIRAR ELEMENTOS SUSTITUIDOS TRAS REPARACIÓN", "autoriza.renunciaRetirar", 220, 175, 64, 8, 5, true),
      tx2("Protección de Datos de Carácter Personal: con la firma del presente usted, presta su consentimiento para que sus datos, sean tratados mientras que no comunique lo contrario por este taller, con la finalidad de gestión contable/administrativa de los servicios. Podrá ejercitar sus derechos de acceso, rectificación, supresión, oposición, y los demás reconocidos en esta norma, enviando solicitud a la dirección indicada, remitiendo copia de su DNI. Puede ejercitar el derecho a presentar una reclamación ante la Agencia Española de Protección de Datos.", 18, 179, 130, 17, 4.5, false),
      tx2("SI TRANSCURRIDOS TRES DÍAS DESDE LA PUESTA EN CONOCIMIENTO DEL CLIENTE DE LA FINALIZACIÓN DE LOS TRABAJOS DE ELABORACIÓN DEL PRESUPUESTO O REPARACIÓN DEL VEHÍCULO, NO PROCEDE EL CLIENTE AL PRONUNCIAMIENTO SOBRE LA ACEPTACIÓN O NO DEL PRESUPUESTO O A LA RETIRADA DEL VEHÍCULO, SE DEVENGARÁN UNOS GASTOS DIARIOS DE ESTANCIA DE          € MÁS IVA.", 152, 179, 132, 17, 4.5, true),
    ],
  };
}

export function buildRecepcionAparato() {
  const tablaTrabajos = {
    id: id(), type: "table", x: 18, y: 62, w: 132, h: 112,
    columns: [
      { title: "DESCRIPCIÓN", width: 0.67 },
      { title: "MANO DE OBRA", width: 0.165 },
      { title: "MATERIALES", width: 0.165 },
    ],
    rows: 21, headerFontSize: 6, showRowNumbers: true,
    groupTitle: "TRABAJOS A REALIZAR",
  };

  return {
    id: id(),
    builtin: "recepcion-aparato",
    name: "Recepción de Aparato",
    tipoDocumento: "entrada-sat",
    porDefecto: true,
    page: { size: "A4", orientation: "landscape" },
    elements: [
      tx2("EJEMPLAR PARA EL PRESTADOR DEL SERVICIO", 18, 8, 266, 7, 15, true, "center"),
      fld2("NOMBRE", "taller.nombre", 18, 15, 84, 8),
      fld2("CIF", "taller.cif", 107, 15, 35, 8),
      fld2("DIRECCIÓN", "taller.direccion", 18, 25, 84, 8),
      fld2("TELÉFONO", "taller.telefono", 107, 25, 35, 8),
      fld2("MAIL", "taller.mail", 18, 35, 84, 8),
      tx2("RESGUARDO DE DEPÓSITO Nº:", 152, 16.5, 62, 4, 7, true),
      fld2("", "resguardo.numero", 218, 15.5, 44, 6),
      fld2("CLIENTE", "cliente.titular", 152, 23, 80, 8),
      fld2("CIF/DNI", "cliente.cifTitular", 236, 23, 48, 8),
      fld2("DIRECCIÓN", "cliente.direccion", 152, 31.5, 80, 8),
      fld2("TELÉFONO", "cliente.telefono", 236, 31.5, 48, 8),
      fld2("MAIL", "cliente.mail", 152, 40, 80, 8),
      fld2("FECHA", "aparato.fecha", 152, 51, 30, 8),
      fld2("TIPO", "aparato.tipo", 186, 51, 40, 8),
      fld2("MARCA", "aparato.marca", 230, 51, 26, 8),
      fld2("MODELO", "aparato.modelo", 260, 51, 24, 8),
      fld2("Nº DE SERIE", "aparato.serie", 152, 61, 44, 8),
      tx2("GARANTÍA", 200, 64, 22, 4, 6, true),
      chk("SI", "aparato.garantiaSi", 224, 63, 11, 5),
      chk("NO", "aparato.garantiaNo", 236, 63, 12, 5),
      fld2("ACCESORIOS QUE ENTREGA", "aparato.accesorios", 152, 71, 132, 8),
      area("ESTADO FÍSICO / DESPERFECTOS VISIBLES", "aparato.estadoFisico", 152, 81, 132, 12),
      area("AVERÍA / SÍNTOMA DESCRITO POR EL CLIENTE", "aparato.averia", 152, 95, 132, 12),
      fld2("DIRECCIÓN DE LA INTERVENCIÓN (SERVICIO A DOMICILIO)", "aparato.direccion", 152, 109, 132, 8),
      tablaTrabajos,
      box2(152, 121, 132, 29, 2),
      tx2("RENUNCIA A LA ELABORACIÓN", 156, 123, 124, 6, 12, true, "center"),
      tx2("DE PRESUPUESTO PREVIO", 156, 129.5, 124, 6, 12, true, "center"),
      tx2("EL CLIENTE TIENE DERECHO A LA ELABORACIÓN DE UN PRESUPUESTO PREVIO. MEDIANTE LA PRESENTE FIRMA EL USUARIO RENUNCIA A LA ELABORACIÓN DE PRESUPUESTO PREVIO Y AUTORIZA A REALIZAR LOS TRABAJOS NECESARIOS PARA LA REPARACIÓN DEL APARATO Y/O SERVICIOS SOLICITADOS CONFORME A LO REFLEJADO EN ESTE RESGUARDO DE DEPÓSITO.", 157, 137, 122, 12, 5, true),
      tx2("EL PRESTADOR DEL SERVICIO", 157, 153, 62, 3.5, 6, true),
      tx2("CONFORME CLIENTE", 224, 153, 56, 3.5, 6, true),
      tx2("NOMBRE Y FIRMA", 157, 157.5, 62, 4, 7, false),
      firma("", "", 224, 156, 56, 10),
      tx2("FECHA PREVISTA DE ENTREGA DEL APARATO REPARADO", 160, 170, 88, 4, 7, true),
      fld2("", "entrega.fechaPrevista", 250, 169, 34, 6),
      tx2("Protección de Datos de Carácter Personal: con la firma del presente usted, presta su consentimiento para que sus datos, sean tratados mientras que no comunique lo contrario por esta empresa, con la finalidad de gestión contable/administrativa de los servicios. Podrá ejercitar sus derechos de acceso, rectificación, supresión, oposición, y los demás reconocidos en esta norma, enviando solicitud a la dirección indicada, remitiendo copia de su DNI. Puede ejercitar el derecho a presentar una reclamación ante la Agencia Española de Protección de Datos.", 18, 179, 130, 17, 4.5, false),
      tx2("SI TRANSCURRIDOS TRES DÍAS DESDE LA PUESTA EN CONOCIMIENTO DEL CLIENTE DE LA FINALIZACIÓN DE LOS TRABAJOS DE ELABORACIÓN DEL PRESUPUESTO O REPARACIÓN DEL APARATO, NO PROCEDE EL CLIENTE AL PRONUNCIAMIENTO SOBRE LA ACEPTACIÓN O NO DEL PRESUPUESTO O A LA RETIRADA DEL APARATO, SE DEVENGARÁN UNOS GASTOS DIARIOS DE ESTANCIA DE          € MÁS IVA.", 152, 179, 132, 17, 4.5, true),
    ],
  };
}

export function buildCitaTaller() {
  const x = 20;
  const w = 170;
  const medio = w / 2;
  const gris = "#6b7280";
  const oscuro = "#111827";

  // Campo con etiqueta y línea inferior (sin recuadro completo)
  const fl = (label, key, px, py, pw, ph = 7, pfs = 9) => ({
    id: id(), type: "field", x: px, y: py, w: pw, h: ph,
    label, fieldKey: key, fontSize: pfs, boxed: false,
  });

  return {
    id: id(),
    builtin: "cita-taller",
    name: "Justificante de cita (taller)",
    tipoDocumento: "cita-taller",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),

      tx("JUSTIFICANTE DE CITA", 110, 16, 80, 10, 20, true, "right", oscuro),
      tx("CITA DE TALLER REGISTRADA", 110, 27, 80, 5, 9, false, "right", gris),
      fl("", "cita.numero", 110, 34, 80, 6, 11),

      // Datos del emisor
      tx("Taller", x, 46, w, 5, 7, true, "left", gris),
      fl("", "empresa.nombre", x, 51, w, 8, 11),
      fl("", "empresa.nif", x, 60, w, 5, 8),
      fl("", "empresa.direccion", x, 66, w, 5, 8),
      fl("", "empresa.telefono", x, 72, w, 5, 8),
      linea(x, 80, w, "#d1d5db"),

      // Datos de la cita
      tx("DATOS DE LA CITA", x, 88, w, 6, 10, true, "left", oscuro),
      fl("FECHA", "cita.fecha", x, 97, medio - 2),
      fl("HORARIO RECEPCIÓN", "cita.horario", x + medio + 2, 97, medio - 2),
      fl("ESTADO", "cita.estado", x, 107, medio - 2),
      fl("ASEGURADORA / PARTICULAR", "cita.aseguradora", x + medio + 2, 107, medio - 2),
      linea(x, 118, w, "#d1d5db"),

      // Cliente
      tx("CLIENTE", x, 126, w, 6, 10, true, "left", oscuro),
      fl("NOMBRE", "cliente.nombre", x, 135, w, 8, 10),
      fl("NIF / CIF", "cliente.nif", x, 145, medio - 2),
      fl("TELÉFONO", "cliente.telefono", x + medio + 2, 145, medio - 2),
      fl("CORREO ELECTRÓNICO", "cliente.email", x, 155, w),
      linea(x, 166, w, "#d1d5db"),

      // Vehículo
      tx("VEHÍCULO", x, 174, w, 6, 10, true, "left", oscuro),
      fl("MATRÍCULA", "vehiculo.matricula", x, 183, medio - 2, 8, 10),
      fl("MARCA", "vehiculo.marca", x + medio + 2, 183, medio - 2, 8, 9),
      fl("MODELO", "vehiculo.modelo", x, 193, medio - 2),
      fl("CORTESÍA", "cita.cortesia", x + medio + 2, 193, medio - 2),
      linea(x, 204, w, "#d1d5db"),

      // Motivo
      tx("MOTIVO / TRABAJO SOLICITADO", x, 212, w, 6, 10, true, "left", oscuro),
      { id: id(), type: "textarea", x, y: 221, w, h: 40, label: "", fieldKey: "cita.motivo", fontSize: 9, boxed: false },

      // Pie
      tx(
        "Este justificante confirma que el taller ha registrado la cita indicada. No supone la aceptación de un presupuesto ni la apertura de una orden de reparación.",
        x, 268, w, 10, 8, false, "center", gris
      ),
      linea(x, 282, w, "#d1d5db"),
      tx("Documento emitido el", x, 287, 38, 5, 8, false, "left", gris),
      fl("", "documento.fechaEmision", x + 40, 287, 60, 5, 8),
    ],
  };
}

export function buildContratoCortesia() {
  const fs = 8;
  const fsSec = 9;
  const fsTitle = 14;
  const x = 12;
  const w = 186;
  const medio = w / 2;
  const tercio = w / 3;

  const txc = (text, px, py, pw, ph, pfs = fs, bold = false, align = "left", color = "#000") =>
    tx2(text, px, py, pw, ph, pfs, bold, align, color);
  const fl = (label, key, px, py, pw, ph = 6, pfs = fs) => ({
    ...fld2(label, key, px, py, pw, ph, pfs),
    mostrarEtiquetaImpresion: true,
  });
  const seccion = (text, px, py, pw) => [
    { id: id(), type: "rect", x: px, y: py, w: pw, h: 5.5, borderWidth: 0.8, borderColor: "#000", background: "#e6e6e6" },
    txc(text, px, py + 1, pw, 4, fsSec, true, "center", "#000"),
  ];

  const yUsuario = 36;
  const yVehDisp = 108;
  const yKm = 136;
  const yEstado = 162;
  const ySeguro = 196;
  const yRep = 235;
  const yFirmas = 264;

  return {
    id: id(),
    builtin: "contrato-cortesia",
    name: "Contrato de cortesía",
    tipoDocumento: "contrato-cortesia",
    porDefecto: true,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      // Logotipo de la empresa arriba a la izquierda (la cabecera es texto
      // centrado, así que no molesta). Se resuelve al imprimir con el logo
      // subido en Ajustes → Configuración.
      logo(12, 6, 36, 18),

      // Cabecera
      txc("{{empresa.nombre}}", x, 8, w, 6, 11, true, "center"),
      txc("{{empresa.direccion}}", x, 14, w, 4, 8, false, "center", "#333"),
      txc("{{empresa.telefono}}", x, 18, w, 4, 8, false, "center", "#333"),

      txc("VEHÍCULOS DE SUSTITUCIÓN", x, 22, w, 7, fsTitle, true, "center"),
      txc("Contrato de prestación con participación forfait Nº", x, 29, 145, 5, 9, false, "center"),
      fl("", "prestamo.numero", 160, 29, 38, 6),

      // USUARIO
      ...seccion("USUARIO", x, yUsuario, w),
      txc("Atención: Toda persona que conduzca el vehículo prestado, debe ser mayor de edad y poseer un permiso o licencia de conducir desde hace más de 1 año, y no estar en suspenso o anulado.", x + 1, yUsuario + 6, w - 2, 5.5, 6.5, false, "justify"),
      fl("Apellidos", "cliente.apellidos", x, yUsuario + 12, medio - 2),
      fl("Nombre", "cliente.nombre", x + medio, yUsuario + 12, medio - 2),
      fl("Fecha de nacimiento", "cliente.fechaNacimiento", x, yUsuario + 19, medio - 2),
      fl("Lugar de nacimiento", "cliente.lugarNacimiento", x + medio, yUsuario + 19, medio - 2),
      fl("Dirección", "cliente.direccion", x, yUsuario + 26, w),
      fl("Tlf. Particular", "cliente.telefono", x, yUsuario + 33, medio - 2),
      fl("Móvil", "cliente.movil", x + medio, yUsuario + 33, medio - 2),
      fl("Trabajo", "cliente.telefonoTrabajo", x, yUsuario + 40, w),
      fl("Permiso de conducir nº", "cliente.permisoNumero", x, yUsuario + 47, w),
      fl("Expedido el", "cliente.permisoExpedicion", x, yUsuario + 54, medio - 2),
      fl("en", "cliente.permisoLugar", x + medio, yUsuario + 54, medio - 2),
      fl("Eventualmente, otros conductores admitidos", "cliente.otrosConductores", x, yUsuario + 61, w),

      // VEHÍCULO PUESTO A DISPOSICIÓN
      ...seccion("VEHÍCULO PUESTO A DISPOSICIÓN", x, yVehDisp, w),
      fl("Marca", "vehiculo.marca", x, yVehDisp + 6, 60, 6),
      fl("Modelo", "vehiculo.modelo", x + 64, yVehDisp + 6, 60, 6),
      fl("Nº Matrícula", "vehiculo.matricula", x + 128, yVehDisp + 6, 58, 6),
      fl("V.I.N.", "vehiculo.vin", x, yVehDisp + 14, medio - 2),
      fl("Participación forfait diaria (€)", "vehiculo.forfaitDiario", x + medio, yVehDisp + 14, medio - 2),

      // Tabla salida/retorno
      {
        id: id(),
        type: "table",
        x,
        y: yKm,
        w,
        h: 24,
        columns: [
          { title: "", width: 0.2 },
          { title: "SALIDA", width: 0.27 },
          { title: "RETORNO PREVISTO", width: 0.27 },
          { title: "RETORNO REAL", width: 0.26 },
        ],
        rows: 3,
        headerFontSize: 7,
        showRowNumbers: false,
        groupTitle: "",
        estilo: "rejilla",
      },
      // ESTADO DEL VEHÍCULO
      ...seccion("ESTADO DEL VEHÍCULO", x, yEstado, medio - 2),
      txc("[imagen lateral]", x + 5, yEstado + 7, 80, 5, 6, false, "center", "#999"),
      txc("[imagen superior]", x + 5, yEstado + 24, 80, 5, 6, false, "center", "#999"),
      txc("[imagen frontal]", x + 5, yEstado + 41, 38, 5, 6, false, "center", "#999"),
      txc("[imagen trasera]", x + 47, yEstado + 41, 38, 5, 6, false, "center", "#999"),

      // Observaciones
      box2(x + medio, yEstado, medio - 2, 32, 0.8),
      txc("OBSERVACIONES", x + medio + 1, yEstado + 1, medio - 4, 5, fsSec, true, "center"),
      { id: id(), type: "textarea", x: x + medio + 2, y: yEstado + 7, w: medio - 6, h: 24, label: "", fieldKey: "vehiculo.observaciones", fontSize: 7.5, boxed: false },

      // SEGURO
      ...seccion("SEGURO", x, ySeguro, w),
      fl("Asegurador", "seguro.asegurador", x, ySeguro + 6, medio - 2),
      fl("Nº de Contrato", "seguro.numeroContrato", x + medio, ySeguro + 6, medio - 2),
      txc("Montante de las franquicias:", x + 1, ySeguro + 12, w - 2, 5, 7, true),
      fl("Daños causados a terceros", "seguro.franquiciaTerceros", x, ySeguro + 18, tercio - 2),
      fl("Daños causados al vehículo", "seguro.franquiciaVehiculo", x + tercio, ySeguro + 18, tercio - 2),
      fl("Robo/Vandalismo", "seguro.franquiciaRobo", x + tercio * 2, ySeguro + 18, tercio - 2),
      chk("Rescate de franquicias: SI", "seguro.rescateSi", x + 1, ySeguro + 25, 34, 5, 7),
      chk("NO", "seguro.rescateNo", x + 38, ySeguro + 25, 18, 5, 7),
      chk("Transferencia de seguro: SI", "seguro.transferenciaSi", x + 80, ySeguro + 25, 44, 5, 7),
      chk("NO", "seguro.transferenciaNo", x + 128, ySeguro + 25, 18, 5, 7),
      fl("Montante del rescate por día", "seguro.rescatePorDia", x, ySeguro + 31, w),
      txc("*Aporta un justificante de alteración de seguro", x + 1, ySeguro + 37, w - 2, 4, 6, false, "left", "#555"),

      // VEHÍCULO EN REPARACIÓN
      ...seccion("VEHÍCULO EN REPARACIÓN", x, yRep, w),
      fl("Modelo", "reparacion.modelo", x, yRep + 7, medio - 2),
      fl("Nº de matrícula", "reparacion.matricula", x + medio, yRep + 7, medio - 2),
      fl("V.I.N.", "reparacion.vin", x, yRep + 14, w),
      fl("Nº de O.R.", "reparacion.numeroOrden", x, yRep + 21, medio - 2),
      fl("Entrega prevista", "reparacion.entregaPrevista", x + medio, yRep + 21, medio - 2),

      // Firmas
      box2(x, yFirmas, tercio - 2, 24, 0.8),
      txc("Declaro haber tenido conocimiento de las condiciones generales de protección indicadas al dorso del presente Contrato.", x + 2, yFirmas + 2, tercio - 6, 12, 6, true, "center"),
      txc("Realizado en _______ a ____/____/________", x + 2, yFirmas + 16, tercio - 6, 4.5, 6, false, "center"),
      txc("Firma del cliente", x + 2, yFirmas + 21, tercio - 6, 4.5, 6, false, "center"),

      box2(x + tercio, yFirmas, tercio - 2, 24, 0.8),
      txc("El cliente (firma)", x + tercio + 2, yFirmas + 2, tercio - 6, 4.5, 6, true, "center"),
      txc("El concesionario (nombre y firma)", x + tercio + 2, yFirmas + 7, tercio - 6, 4.5, 6, true, "center"),
      txc("Fecha: ____/____/________", x + tercio + 2, yFirmas + 19, tercio - 6, 4.5, 6, false, "center"),

      box2(x + tercio * 2, yFirmas, tercio - 2, 24, 0.8),
      txc("Al retorno, el cliente (firma)", x + tercio * 2 + 2, yFirmas + 2, tercio - 6, 12, 6, true, "center"),
      txc("Fecha: ____/____/________", x + tercio * 2 + 2, yFirmas + 19, tercio - 6, 4.5, 6, false, "center"),

      txc("ATENCIÓN: Este contrato debe ir acompañado al vehículo durante toda la duración de la prestación.", x, yFirmas + 28, w, 4.5, 7, true, "center"),
    ].flat(),
  };
}

// Factura de taller (chapa y pintura): las líneas llegan ya agrupadas del
// servidor en bloques (PIEZAS SUSTITUIDAS / MANO DE OBRA CHAPA / MANO DE OBRA
// PINTURA-MATERIAL) con cabecera y subtotal por bloque, y los totales
// muestran Total reparación, Franquicia y Descuento solo cuando aplican.
export function buildFacturaVentaTaller() {
  const cols = [
    { title: "CONCEPTO", width: 0.46 },
    { title: "CANT.", width: 0.09 },
    { title: "PRECIO", width: 0.13 },
    { title: "DTO", width: 0.08 },
    { title: "IVA", width: 0.08 },
    { title: "IMPORTE", width: 0.16 },
  ];
  const t = tabla(20, 101, 170, 116, "DETALLE DE LA REPARACIÓN", cols, 19);
  return {
    id: id(),
    builtin: "factura-venta-taller",
    name: "Factura Taller",
    tipoDocumento: "factura-venta",
    porDefecto: false,
    page: { size: "A4", orientation: "portrait" },
    elements: [
      logo(20, 14, 45, 22),
      tx("FACTURA", 102, 16, 60, 10, 18, true, "right", "#111827"),
      tx("{{documento.numero}}", 102, 27, 60, 6, 11, false, "right", "#4b5563"),
      tx("Fecha: {{documento.fecha}}", 102, 34, 60, 5, 9, false, "right", "#6b7280"),

      box(20, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("EMISOR", 23, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{empresa.nombre}}", 23, 51, 74, 8, 10, true),
      tx("{{empresa.nif}}", 23, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{empresa.direccion}}", 23, 65, 74, 7, 8, false, "left", "#374151"),

      box(110, 42, 80, 32, 0.4, "#e5e7eb"),
      tx("CLIENTE", 113, 45, 74, 5, 7, true, "left", "#6b7280"),
      tx("{{cliente.nombre}}", 113, 51, 74, 8, 10, true),
      tx("{{cliente.nif}}", 113, 60, 74, 5, 8, false, "left", "#374151"),
      tx("{{cliente.direccion}}", 113, 65, 74, 7, 8, false, "left", "#374151"),

      box(20, 77, 170, 20, 0.4, "#e5e7eb"),
      tx("DATOS DEL TRABAJO", 23, 80, 164, 4, 7, true, "left", "#6b7280"),
      tx("Matrícula: {{taller.matricula}}    Vehículo: {{taller.vehiculo}}    KM: {{taller.km}}    Orden: {{taller.orden}}", 23, 85, 164, 4.5, 8, false, "left", "#111827"),
      tx("Compañía: {{taller.aseguradora}}    Siniestro: {{taller.siniestro}}    Entrada: {{taller.fechaEntrada}}", 23, 90.5, 164, 4.5, 8, false, "left", "#111827"),

      t,

      box(120, 222, 70, 52, 0.4, "#e5e7eb"),
      tx("{{totales.totalReparacionLabel}}", 124, 226, 42, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.totalReparacion}}", 166, 226, 20, 5, 9, true, "right"),
      tx("{{totales.franquiciaLabel}}", 124, 233, 42, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.franquicia}}", 166, 233, 20, 5, 9, true, "right"),
      tx("{{totales.descuentoLabel}}", 124, 240, 42, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.descuento}}", 166, 240, 20, 5, 9, true, "right"),
      tx("Base imponible", 124, 249, 42, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.base}}", 166, 249, 20, 5, 9, true, "right"),
      tx("IVA", 124, 256, 42, 5, 9, false, "left", "#4b5563"),
      tx("{{totales.iva}}", 166, 256, 20, 5, 9, true, "right"),
      linea(124, 263, 62, "#9ca3af"),
      tx("TOTAL", 124, 267, 42, 7, 11, true, "left"),
      tx("{{totales.total}}", 166, 267, 20, 7, 11, true, "right"),

      tx("Forma de pago: {{pago.metodo}}", 20, 226, 90, 5, 9, false, "left", "#4b5563"),
      tx("Vencimiento: {{pago.vencimiento}}", 20, 234, 90, 5, 9, false, "left", "#4b5563"),
      tx("{{notas}}", 20, 244, 95, 20, 8, false, "left", "#6b7280"),

      tx("Gracias por confiar en nosotros", 20, 282, 170, 5, 8, false, "center", "#9ca3af"),
    ],
  };
}

export const BUILTIN_TEMPLATES = [
  buildFacturaVenta,
  buildFacturaVentaTaller,
  buildPresupuestoVenta,
  buildAlbaranVenta,
  buildPedidoCliente,
  buildParteTaller,
  buildTrabajosRealizar,
  buildParteSat,
  buildRecepcionVehiculo,
  buildRecepcionAparato,
  buildCitaTaller,
  buildContratoCortesia,
];
